import AssessmentPage from "../components/Assessments";

function AssessmentDetailPage() {
  return (
    <>
      <AssessmentPage />
    </>
  );
}

export default AssessmentDetailPage;
